// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-screener-table-header-index,
.fund-screener-table-index {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  text-align: center;
  box-sizing: border-box;
}

/* Dedicated classes — do not reuse .fund-screener-table-cell-value(-container),
   same specificity would let NAV/TNA's flex-end/text-primary silently win. */
.fund-screener-table-index-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-bottom: 15px;
}

.fund-screener-table-index-number {
  color: var(--text-label);
}

.fund-screener-table-header-flag,
.fund-screener-table-flag {
  /* Hug the 20x20 flag icon: 20 + 6px padding each side = 32px total. Must
     match FLAG_COLUMN_WIDTH in FundScreenerTable.tsx exactly — the sticky
     Name column's \`left\` offset below is computed from that constant, not
     measured from the DOM. */
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  padding: 0 6px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
}

.fund-screener-table-header-name,
.fund-screener-table-name {
  width: 320px;
  min-width: 320px;
  max-width: 320px;
  padding-right: 16px;
  box-sizing: border-box;
  white-space: nowrap;
  position: relative;
}

/* Mobile drops the index column, so Name shrinks to make room instead of
   staying at the desktop 320px. */
.fund-screener-table-name-mobile,
.fund-screener-table-header-name-mobile {
  width: 160px;
  min-width: 160px;
  max-width: 160px;
}

.fund-screener-table-name::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px;
  background-color: var(--border-tertiary);
}

.fund-screener-table-nav {
  min-width: 140px;
  box-sizing: border-box;
}

.fund-screener-table-dynamic {
  min-width: 140px;
  box-sizing: border-box;
}

.fund-screener-table-tna {
  min-width: 170px;
  box-sizing: border-box;
}

/* Without its own min-width, the header shrinks and longer labels overflow
   into the next column. */
.fund-screener-table-header-nav,
.fund-screener-table-header-dynamic {
  min-width: 140px;
  box-sizing: border-box;
}

.fund-screener-table-header-tna {
  min-width: 170px;
  box-sizing: border-box;
}

/* Mobile: narrower than the desktop min-width — the full 140px/170px reads
   as unnecessarily wide right after Name on a small screen. Compound
   selector (2 classes) outranks the base single-class rules above. */
.fund-screener-table-nav.fund-screener-table-nav-mobile,
.fund-screener-table-header-nav.fund-screener-table-header-nav-mobile {
  min-width: 100px;
}

.fund-screener-table-tna.fund-screener-table-tna-mobile,
.fund-screener-table-header-tna.fund-screener-table-header-tna-mobile {
  min-width: 130px;
}

/* Score-type criteria (Total/Consistent/Preservation/Expenses score) render a
   circular badge that needs a wider left gap than plain value columns. */
.fund-screener-table-dynamic-score {
  padding-left: 36px;
}

.fund-screener-table-cell-badge-container {
  display: flex;
  justify-content: flex-end;
}

/* Freeze Index + Flag + Name; everything after scrolls horizontally, hidden behind the frozen columns (mobile and desktop alike) */
.fund-screener-table-container {
  overflow: auto;
}

.fund-screener-table-container table {
  border-collapse: separate;
  border-spacing: 0;
  /* Must be a plain CSS rule, not MUI \`sx\` on <Table> — sx doesn't reliably
     win here, leaving columns on default auto-layout sizing. */
  table-layout: fixed;
}

.fund-screener-table-index-sticky,
.fund-screener-table-header-index-sticky,
.fund-screener-table-flag-sticky,
.fund-screener-table-header-flag-sticky,
.fund-screener-table-name-sticky,
.fund-screener-table-header-name-sticky {
  position: sticky;
  z-index: 3;
  background-color: var(--row-light);
  /* Forces each sticky cell onto its own stable compositor layer, fixing a
     Chrome rendering seam (hairline gap) that can appear between adjacent
     sticky cells. */
  transform: translateZ(0);
}

.fund-screener-table-index-sticky,
.fund-screener-table-header-index-sticky {
  left: 0px;
}

.fund-screener-table-flag-sticky,
.fund-screener-table-header-flag-sticky {
  left: 30px;
}

.fund-screener-table-name-sticky,
.fund-screener-table-header-name-sticky {
  left: 62px;
}

/* Mobile drops the index column, so flag becomes the first frozen column
   (left: 0) and name shifts in by just flag's width (left: 32), not
   index + flag's combined 62px. */
.fund-screener-table-flag-sticky.fund-screener-table-flag-mobile,
.fund-screener-table-header-flag-sticky.fund-screener-table-header-flag-mobile {
  left: 0px;
}

.fund-screener-table-name-sticky.fund-screener-table-name-mobile,
.fund-screener-table-header-name-sticky.fund-screener-table-header-name-mobile {
  left: 32px;
}

/* MUI's stickyHeader injects its own position/z-index per <th>, outranking
   the plain classes above — re-assert with higher specificity here. */
th.fund-screener-table-header-index-sticky,
th.fund-screener-table-header-flag-sticky,
th.fund-screener-table-header-name-sticky {
  position: sticky;
  z-index: 3;
  background-color: var(--row-light);
}

.fund-screener-table-header-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.fund-screener-table-header-wrapper.align-right {
  justify-content: flex-end;
}

.fund-screener-table-header-name-code {
  cursor: default;
  gap: 12px;
}

.fund-screener-table-header-sort-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.fund-screener-table-sorting-icon {
  width: 16px;
  height: 16px;
}

.fund-screener-table-sorting-icon--fill path {
  fill: var(--color-brand);
}

.fund-screener-table-cell-flag svg {
  width: 20px;
  height: 20px;
}

.fund-screener-table-cell-name-container {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
}

.fund-screener-table-cell-name {
  color: var(--text-instrument);
  overflow: hidden;
  text-overflow: ellipsis;
}

.fund-screener-table-cell-name-attrs {
  color: var(--text-label);
}

.fund-screener-table-cell-code {
  color: var(--text-ticker);
  font-weight: 700;
  cursor: pointer;
}

.fund-screener-table-cell-asset-type {
  color: var(--text-label);
}

.fund-screener-table-cell-value-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.fund-screener-table-cell-value {
  color: var(--text-primary);
}

.fund-screener-table-cell-currency {
  color: var(--text-secondary);
}

.fund-screener-table-cell-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Left-aligned (unlike NAV/TNA's right-aligned two-line container) — a
   right-aligned short name vs. a left-truncated long name looked
   inconsistent side by side. Bounded width still needed for the ellipsis
   to have something to truncate against. */
.fund-screener-table-cell-company-container {
  width: 100%;
  align-items: flex-start;
}

.fund-screener-table-cell-company-container .fund-screener-table-cell-value {
  width: 100%;
  text-align: left;
}

.fund-screener-table-cell-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--accent-primary);
  color: var(--text-invert);
}

.fund-screener-table-cell-badge-empty {
  text-align: right;
  color: var(--text-label);
}

.fund-screener-table-cell-badge-na {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--border-line);
  font-size: 10px;
  font-weight: 600;
}

.fund-screener-table-cell-perf {
  text-align: right;
}

.fund-screener-table-cell-perf.positive {
  color: var(--text-up-color);
}

.fund-screener-table-cell-perf.negative {
  color: var(--text-down-color);
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/FundScreenerTable.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;6EAC6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;;;6BAG2B;EAC3B,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;kCACkC;AAClC;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;0BAC0B;AAC1B;;EAEE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;qEAEqE;AACrE;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;yEACyE;AACzE;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,mIAAmI;AACnI;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB;+DAC6D;EAC7D,mBAAmB;AACrB;;AAEA;;;;;;EAME,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC;;oBAEkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;kCAEkC;AAClC;;EAEE,SAAS;AACX;;AAEA;;EAEE,UAAU;AACZ;;AAEA;sEACsE;AACtE;;;EAGE,gBAAgB;EAChB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;2CAG2C;AAC3C;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".fund-screener-table-header-index,\n.fund-screener-table-index {\n  width: 30px;\n  min-width: 30px;\n  max-width: 30px;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n/* Dedicated classes — do not reuse .fund-screener-table-cell-value(-container),\n   same specificity would let NAV/TNA's flex-end/text-primary silently win. */\n.fund-screener-table-index-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 15px;\n}\n\n.fund-screener-table-index-number {\n  color: var(--text-label);\n}\n\n.fund-screener-table-header-flag,\n.fund-screener-table-flag {\n  /* Hug the 20x20 flag icon: 20 + 6px padding each side = 32px total. Must\n     match FLAG_COLUMN_WIDTH in FundScreenerTable.tsx exactly — the sticky\n     Name column's `left` offset below is computed from that constant, not\n     measured from the DOM. */\n  width: 32px;\n  min-width: 32px;\n  max-width: 32px;\n  padding: 0 6px;\n  box-sizing: border-box;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.fund-screener-table-header-name,\n.fund-screener-table-name {\n  width: 320px;\n  min-width: 320px;\n  max-width: 320px;\n  padding-right: 16px;\n  box-sizing: border-box;\n  white-space: nowrap;\n  position: relative;\n}\n\n/* Mobile drops the index column, so Name shrinks to make room instead of\n   staying at the desktop 320px. */\n.fund-screener-table-name-mobile,\n.fund-screener-table-header-name-mobile {\n  width: 160px;\n  min-width: 160px;\n  max-width: 160px;\n}\n\n.fund-screener-table-name::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 1px;\n  background-color: var(--border-tertiary);\n}\n\n.fund-screener-table-nav {\n  min-width: 140px;\n  box-sizing: border-box;\n}\n\n.fund-screener-table-dynamic {\n  min-width: 140px;\n  box-sizing: border-box;\n}\n\n.fund-screener-table-tna {\n  min-width: 170px;\n  box-sizing: border-box;\n}\n\n/* Without its own min-width, the header shrinks and longer labels overflow\n   into the next column. */\n.fund-screener-table-header-nav,\n.fund-screener-table-header-dynamic {\n  min-width: 140px;\n  box-sizing: border-box;\n}\n\n.fund-screener-table-header-tna {\n  min-width: 170px;\n  box-sizing: border-box;\n}\n\n/* Mobile: narrower than the desktop min-width — the full 140px/170px reads\n   as unnecessarily wide right after Name on a small screen. Compound\n   selector (2 classes) outranks the base single-class rules above. */\n.fund-screener-table-nav.fund-screener-table-nav-mobile,\n.fund-screener-table-header-nav.fund-screener-table-header-nav-mobile {\n  min-width: 100px;\n}\n\n.fund-screener-table-tna.fund-screener-table-tna-mobile,\n.fund-screener-table-header-tna.fund-screener-table-header-tna-mobile {\n  min-width: 130px;\n}\n\n/* Score-type criteria (Total/Consistent/Preservation/Expenses score) render a\n   circular badge that needs a wider left gap than plain value columns. */\n.fund-screener-table-dynamic-score {\n  padding-left: 36px;\n}\n\n.fund-screener-table-cell-badge-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Freeze Index + Flag + Name; everything after scrolls horizontally, hidden behind the frozen columns (mobile and desktop alike) */\n.fund-screener-table-container {\n  overflow: auto;\n}\n\n.fund-screener-table-container table {\n  border-collapse: separate;\n  border-spacing: 0;\n  /* Must be a plain CSS rule, not MUI `sx` on <Table> — sx doesn't reliably\n     win here, leaving columns on default auto-layout sizing. */\n  table-layout: fixed;\n}\n\n.fund-screener-table-index-sticky,\n.fund-screener-table-header-index-sticky,\n.fund-screener-table-flag-sticky,\n.fund-screener-table-header-flag-sticky,\n.fund-screener-table-name-sticky,\n.fund-screener-table-header-name-sticky {\n  position: sticky;\n  z-index: 3;\n  background-color: var(--row-light);\n  /* Forces each sticky cell onto its own stable compositor layer, fixing a\n     Chrome rendering seam (hairline gap) that can appear between adjacent\n     sticky cells. */\n  transform: translateZ(0);\n}\n\n.fund-screener-table-index-sticky,\n.fund-screener-table-header-index-sticky {\n  left: 0px;\n}\n\n.fund-screener-table-flag-sticky,\n.fund-screener-table-header-flag-sticky {\n  left: 30px;\n}\n\n.fund-screener-table-name-sticky,\n.fund-screener-table-header-name-sticky {\n  left: 62px;\n}\n\n/* Mobile drops the index column, so flag becomes the first frozen column\n   (left: 0) and name shifts in by just flag's width (left: 32), not\n   index + flag's combined 62px. */\n.fund-screener-table-flag-sticky.fund-screener-table-flag-mobile,\n.fund-screener-table-header-flag-sticky.fund-screener-table-header-flag-mobile {\n  left: 0px;\n}\n\n.fund-screener-table-name-sticky.fund-screener-table-name-mobile,\n.fund-screener-table-header-name-sticky.fund-screener-table-header-name-mobile {\n  left: 32px;\n}\n\n/* MUI's stickyHeader injects its own position/z-index per <th>, outranking\n   the plain classes above — re-assert with higher specificity here. */\nth.fund-screener-table-header-index-sticky,\nth.fund-screener-table-header-flag-sticky,\nth.fund-screener-table-header-name-sticky {\n  position: sticky;\n  z-index: 3;\n  background-color: var(--row-light);\n}\n\n.fund-screener-table-header-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.fund-screener-table-header-wrapper.align-right {\n  justify-content: flex-end;\n}\n\n.fund-screener-table-header-name-code {\n  cursor: default;\n  gap: 12px;\n}\n\n.fund-screener-table-header-sort-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n\n.fund-screener-table-sorting-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.fund-screener-table-sorting-icon--fill path {\n  fill: var(--color-brand);\n}\n\n.fund-screener-table-cell-flag svg {\n  width: 20px;\n  height: 20px;\n}\n\n.fund-screener-table-cell-name-container {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.fund-screener-table-cell-name {\n  color: var(--text-instrument);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fund-screener-table-cell-name-attrs {\n  color: var(--text-label);\n}\n\n.fund-screener-table-cell-code {\n  color: var(--text-ticker);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.fund-screener-table-cell-asset-type {\n  color: var(--text-label);\n}\n\n.fund-screener-table-cell-value-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.fund-screener-table-cell-value {\n  color: var(--text-primary);\n}\n\n.fund-screener-table-cell-currency {\n  color: var(--text-secondary);\n}\n\n.fund-screener-table-cell-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Left-aligned (unlike NAV/TNA's right-aligned two-line container) — a\n   right-aligned short name vs. a left-truncated long name looked\n   inconsistent side by side. Bounded width still needed for the ellipsis\n   to have something to truncate against. */\n.fund-screener-table-cell-company-container {\n  width: 100%;\n  align-items: flex-start;\n}\n\n.fund-screener-table-cell-company-container .fund-screener-table-cell-value {\n  width: 100%;\n  text-align: left;\n}\n\n.fund-screener-table-cell-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--accent-primary);\n  color: var(--text-invert);\n}\n\n.fund-screener-table-cell-badge-empty {\n  text-align: right;\n  color: var(--text-label);\n}\n\n.fund-screener-table-cell-badge-na {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--border-line);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.fund-screener-table-cell-perf {\n  text-align: right;\n}\n\n.fund-screener-table-cell-perf.positive {\n  color: var(--text-up-color);\n}\n\n.fund-screener-table-cell-perf.negative {\n  color: var(--text-down-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
